import React, { Component } from 'react';
import { Row, Button } from 'reactstrap';
import { MODERATE_STICKER } from '../../mutation/mutation';
import './sticker.css';

class Sticker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: true,
    };
  }

  moderateSticker(accept) {
    if (accept) {
      const confirm = window.confirm('⚠️ Make this sticker public? It will be available for everyone.');
      if (!confirm) {
        return;
      }
    }
    this.props.client.mutate({
      mutation: MODERATE_STICKER,
      variables: {
        accept,
        stickerId: this.props.sticker._id,
      },
    }).then(({ data = {} }) => {
      if (data.savModerateSticker === true || data.savModerateSticker === false) {
        this.setState({ display: false });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  render() {
    if (!this.state.display) {
      return '';
    }
    return (
      <div className="sticker">
        <Row>
          <img src={this.props.sticker.base64} style={{ height: 75, width: 150 }} alt="sticker"/>
        </Row>
        <Row>
          <Button
            onClick={() => {
              this.moderateSticker(false);
            }}
            color="danger">
            Refuser
          </Button>
          <Button
            onClick={() => {
              this.moderateSticker(true);
            }}
            color="success">
            Accepter
          </Button>
        </Row>
        <hr/>
      </div>
    );
  }
}

export default Sticker;



// WEBPACK FOOTER //
// ./src/components/moderator/sticker.js